import "./testimonial.css";
import AVTR1 from "../../assets/avatar1.jpg";

// import Swiper core and required modules
import { Pagination } from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
const Testimonial = () => {
  return (
    <section id="testimonial">
      <h5>Review from clients</h5>
      <h2>Testimonials</h2>

      <Swiper
        className="container testimonial-container"
        modules={[Pagination]}
        spaceBetween={40}
        slidesPerView={1}
        pagination={{ clickable: true }}
      >
        <SwiperSlide className="testimonial">
          <div className="client-avatar">
            <img src={AVTR1} alt="avatar" />
          </div>
          <h5 className="client-name">Enrish</h5>
          <small className="client-review">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore
            quae adipisci architecto, ipsum repellendus, excepturi itaque
            officia, tenetur aliquid nemo earum quasi iusto maxime aliquam
            ducimus explicabo corporis totam harum!
          </small>
        </SwiperSlide>
        <SwiperSlide className="testimonial">
          <div className="client-avatar">
            <img src={AVTR1} alt="avatar" />
          </div>
          <h5 className="client-name">Enrish</h5>
          <small className="client-review">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Labore
            quae adipisci architecto, ipsum repellendus, excepturi itaque
            officia, tenetur aliquid nemo earum quasi iusto maxime aliquam
            ducimus explicabo corporis totam harum!
          </small>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};
export default Testimonial;
